var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.698 11.075.69 3.185A.93.93 0 0 1 .4 2.492q0-.408.289-.692l.908-.895A1.04 1.04 0 0 1 2.3.601a.9.9 0 0 1 .702.265L9.4 7.17 15.8.866A.9.9 0 0 1 16.5.6q.414.021.703.305l.908.895q.29.285.289.692a.93.93 0 0 1-.289.691l-8.01 7.89a.9.9 0 0 1-.701.326.9.9 0 0 1-.702-.325"
  })));
};
export default SvgChevronDown;